import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { FETCH_BILLING_SCHEDULE_FREQUENCY } from './billingScheduleBreadcrumb.query';

export const BillingScheduleBreadcrumb = () => {
  const { t } = useTranslation('feeAndBilling');
  const { id } = useParams();
  const { data } = useQuery(FETCH_BILLING_SCHEDULE_FREQUENCY, {
    variables: { billingScheduleId: id ?? '' },
    skip: !id,
  });
  const frequency = data?.fetchBillingSchedule?.billingSchedule?.frequency;

  if (!frequency) return '';
  return t(`billingSchedule.frequencies.${frequency}`);
};
